/**
 * Ό,τι συνοδεύει μια γραμμή που έχει ήδη σταλεί στην κουζίνα (dine_in_order_items): επιλογές
 * (ψήσιμο, ζάχαρη …), «χωρίς» υλικά και σχόλιο σερβιτόρου — για να τα βλέπει ο σερβιτόρος στο
 * τραπέζι, όχι μόνο «1× TAGLIATA» (GENERIS 5/10/2026: «κάνε και το ψήσιμο να φαίνεται στο PDA»).
 * Κοινό: PDA (waiter/app/TableSheet) και οθόνη τραπεζιού του ταμείου (dineIn/TableScreen).
 *
 * Οι στήλες jsonb έρχονται συνήθως ως πίνακες· παλιές γραμμές ή άλλοι δρόμοι μπορεί να τις
 * στείλουν ως κείμενο JSON ή null — τίποτα από αυτά δεν σπάει την οθόνη.
 */

export interface ItemModifiers {
  options: string[];
  removed: string[];
  note: string | null;
}

const asList = (value: unknown): any[] => {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string' && value.trim()) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const label = (entry: any, ...keys: string[]): string | null => {
  if (typeof entry === 'string') return entry.trim() || null;
  if (!entry || typeof entry !== 'object') return null;
  for (const key of keys) {
    const v = entry[key];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return null;
};

export function itemModifiers(item: any): ItemModifiers {
  const options = asList(item?.selected_options)
    .map((o) => label(o, 'choice_name', 'name'))
    .filter((s): s is string => !!s);
  const removed = asList(item?.removed_ingredients)
    .map((r) => label(r, 'name'))
    .filter((s): s is string => !!s);
  const note = typeof item?.notes === 'string' && item.notes.trim() ? item.notes.trim() : null;
  return { options, removed, note };
}

export const hasModifiers = (m: ItemModifiers): boolean =>
  m.options.length > 0 || m.removed.length > 0 || m.note !== null;
